import { motion } from "framer-motion";

const PhotoRise = ({ children, riseAmount = 40, duration = 3, className = "" }) => {
  return (
    <motion.div
      initial={{ y: 0 }}
      animate={{ y: -riseAmount }}
      transition={{ duration, ease: "easeInOut" }}
      className={`${className} absolute top-0 left-0 w-full h-[400px]`}
    >
      {children}
    </motion.div>
  );
};

export default PhotoRise;